export default __webpack_public_path__ + "static/media/laugh-emoji.af51e8d0.svg";